interface KeyHelperProps {
  keyName: string;
}

export function KeyHelper({ keyName }: KeyHelperProps) {
  return (
    <>
      <kbd className="invisible md:visible px-1 py-1 text-xs font-semibold text-gray-800 bg-gray-100 border border-gray-200 rounded-sm">
        {keyName}
      </kbd>
      {""}
    </>
  );
}
